import { ArrowUpRight } from 'lucide-react'
import { useModal } from '../contexts/ModalContext'
import FormularioRD from '../rdstation/formularioRD'
import { cn } from '../utils/cn'

export default function BadgetRoxo({
  titulo,
  textoBotao,
  linkBotao,
  className,
}) {
  const { openModal } = useModal()
  return (
    <div
      className={cn(
        'bg-[#2A0D5D] rounded-[10px] py-4 px-8 flex items-center justify-between w-full md:w-fit',
        className,
      )}
    >
      <p className="text-sm md:text-xl font-light text-nowrap ">{titulo}</p>
      <button
        onClick={() => openModal(<FormularioRD />)}
        type="button"
        className="bg-[#A800E4] w-fit flex items-center gap-2.5 rounded-full px-6 py-1.5 text-xs md:text-sm cursor-pointer hover:scale-105 transition-transform duration-300 ease-in-out"
      >
        {textoBotao}
        <ArrowUpRight />
      </button>
    </div>
  )
}
